(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aim-product-addons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aim-product-addons')) {
    customElements.define('aim-product-addons', class extends HTMLElement {
      connectedCallback() {
        this.life = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal: this.life.signal });
        } else {
          this.init();
        }
      }

      init() {
        if (this.started || !this.isConnected || document.querySelector('aim-product-addons[data-running]')) return;
        if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
        this.form = this.findForm();
        if (!this.form) return;
        this.started = true;
        this.dataset.running = 'true';
        this.area = this.form.closest('.shopify-section') || this.form;
        this.dialog = this.querySelector('dialog');
        document.body.appendChild(this.dialog);
        this.cards = Array.from(this.dialog.querySelectorAll('[data-card]'));
        this.confirmButton = this.dialog.querySelector('[data-continue]');
        this.errorBox = this.dialog.querySelector('[data-error]');
        this.phase = 'idle';
        this.replay = false;
        const signal = this.life.signal;
        window.addEventListener('click', event => this.captureClick(event), { capture: true, signal });
        window.addEventListener('submit', event => this.captureSubmit(event), { capture: true, signal });
        this.dialog.addEventListener('change', () => this.updateSummary(), { signal });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          if (this.phase === 'offering') this.dismiss();
        }, { signal });
        this.dialog.querySelector('[data-dismiss]').addEventListener('click', () => this.dismiss(), { signal });
        this.dialog.querySelector('[data-skip]').addEventListener('click', () => this.finish(false), { signal });
        this.confirmButton.addEventListener('click', () => this.finish(true), { signal });
        this.observer = new MutationObserver(() => {
          const form = this.findForm();
          if (form && form !== this.form) {
            this.form = form;
          }
        });
        this.observer.observe(this.area, { childList: true, subtree: true });
      }

      findForm() {
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(form =>
          form.querySelector('[name="product-id"]')?.value === this.dataset.productId &&
          !form.closest('quick-view, quick-add-modal') &&
          !form.matches('.installment, [id^="ProductFormInstallment-"]')
        );
        return forms.find(form => form.matches('[is="product-form"], [data-type="add-to-cart-form"]')) ||
          forms.find(form => form.querySelector('[name="add"], .mw-apo-add-to-cart-cloned'));
      }

      addButton() {
        return this.area.querySelector('.mw-apo-add-to-cart-cloned') || this.form.querySelector('[name="add"]') || this.form.querySelector('[type="submit"]');
      }

      isPurchaseButton(button) {
        if (!button) return false;
        if (button.matches('.mw-apo-buy-it-now-cloned')) return this.form.contains(button);
        if (button.matches('.mw-apo-add-to-cart-cloned')) return this.area.contains(button);
        return (button.form === this.form || this.form.contains(button)) && button.matches('[name="add"], [type="submit"]');
      }

      captureClick(event) {
        const button = event.target.closest?.('button, input[type="submit"], .mw-apo-add-to-cart-cloned');
        if (this.replay || !this.isPurchaseButton(button)) return;
        if (this.phase === 'waiting' && !event.isTrusted) return;
        const checkout = button.matches('.mw-apo-buy-it-now-cloned');
        const nativeButton = checkout ? this.addButton() : button;
        if (!nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true') return;
        if (getComputedStyle(nativeButton).pointerEvents === 'none') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.phase !== 'idle') return;
        this.begin(checkout, () => nativeButton.click(), button);
      }

      captureSubmit(event) {
        if (this.replay || this.phase === 'waiting' || event.target !== this.form) return;
        const button = this.addButton();
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        if (getComputedStyle(button).pointerEvents === 'none') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.phase !== 'idle') return;
        this.begin(false, () => button.click(), event.submitter || button);
      }

      async cart() {
        const response = await fetch(this.dataset.root + 'cart.js', {
          headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(8000)
        });
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }

      countVariant(cart, variantId) {
        return cart.items.reduce((total, item) => total + (String(item.variant_id) === String(variantId) ? item.quantity : 0), 0);
      }

      begin(checkout, action, trigger) {
        this.checkout = checkout;
        this.trigger = trigger;
        this.mainAction = action;
        this.mainQuantity = Math.max(1, Number(new FormData(this.form).get('quantity')) || 1);
        this.showOffers();
      }

      countMainProduct(cart) {
        return cart.items.reduce((total, item) => total + (String(item.product_id) === this.dataset.productId ? item.quantity : 0), 0);
      }

      async addMainProduct() {
        const before = await this.cart();
        if (this.life.signal.aborted) return false;
        const initialQuantity = this.countMainProduct(before);
        this.phase = 'waiting';
        this.replay = true;
        try { this.mainAction(); } finally { this.replay = false; }
        const deadline = Date.now() + 20000;
        let previous = '';
        while (Date.now() < deadline && !this.life.signal.aborted) {
          await new Promise(resolve => setTimeout(resolve, 700));
          const cart = await this.cart();
          if (this.countMainProduct(cart) < initialQuantity + this.mainQuantity) continue;
          const signature = JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price]));
          if (signature === previous) return true;
          previous = signature;
        }
        return false;
      }

      restorePurchaseControls() {
        this.observer?.disconnect();
        this.life.abort();
      }

      showOffers() {
        if (this.life.signal.aborted) return;
        this.phase = 'offering';
        this.cards.forEach(card => { card.querySelector('[data-choice]').checked = false; });
        this.errorBox.hidden = true;
        this.dialog.querySelector('[data-review]').hidden = true;
        this.setBusy(false);
        this.updateSummary();
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }

      selection() {
        const items = [];
        for (const card of this.cards) {
          if (!card.querySelector('[data-choice]').checked) continue;
          const option = card.querySelector('[data-variant]').selectedOptions[0];
          const quantity = this.dataset.matchQuantity === 'true' ? this.mainQuantity : 1;
          const minimum = Number(option.dataset.min) || 1;
          const step = Number(option.dataset.step) || 1;
          const maximum = Number(option.dataset.max) || Infinity;
          if (option.disabled || quantity < minimum || quantity > maximum || quantity % step !== 0) {
            throw new Error('Unsupported add-on quantity');
          }
          items.push({ id: Number(option.value), quantity });
        }
        return items;
      }

      updateSummary() {
        let total = 0;
        let count = 0;
        const quantity = this.dataset.matchQuantity === 'true' ? this.mainQuantity : 1;
        this.cards.forEach(card => {
          const option = card.querySelector('[data-variant]').selectedOptions[0];
          card.querySelector('[data-price]').textContent = option.dataset.money;
          if (card.querySelector('[data-choice]').checked) {
            count += quantity;
            total += Number(option.dataset.price) * quantity;
          }
        });
        const amount = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100);
        this.dialog.querySelector('[data-summary]').textContent = `${count} ${this.dataset.selectedLabel} · ${amount}`;
        this.confirmButton.textContent = this.checkout ? this.dataset.continueCheckout : this.dataset.continueCart;
      }

      setBusy(busy) {
        this.dialog.querySelectorAll('button, select, input').forEach(control => { control.disabled = busy; });
        this.confirmButton.setAttribute('aria-busy', String(busy));
        if (busy) this.confirmButton.textContent = this.dataset.busyLabel;
      }

      async finish(includeExtras) {
        if (this.phase !== 'offering') return;
        let items;
        try {
          items = includeExtras ? this.selection() : [];
        } catch (error) {
          this.errorBox.textContent = this.dataset.addonError;
          this.errorBox.hidden = false;
          return;
        }
        this.phase = 'saving';
        this.setBusy(true);
        this.dialog.close();
        document.documentElement.style.overflow = this.oldOverflow;
        if (!items.length) {
          this.restorePurchaseControls();
          this.trigger?.click();
          return;
        }
        let attemptedWrite = false;
        let mainAdded = false;
        try {
          mainAdded = await this.addMainProduct();
          if (!mainAdded || this.life.signal.aborted) {
            this.restorePurchaseControls();
            return;
          }
          this.phase = 'saving';
          const before = await this.cart();
          if (this.life.signal.aborted) return;
          attemptedWrite = true;
          const response = await fetch(this.dataset.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }), signal: AbortSignal.timeout(15000)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('Add-on request failed');
          const cart = await this.cart();
          if (items.some(item => this.countVariant(cart, item.id) < this.countVariant(before, item.id) + item.quantity)) throw new Error('Add-ons not confirmed');
          if (this.life.signal.aborted) return;
          window.location.assign(this.checkout ? this.dataset.root + 'checkout' : this.dataset.cart);
        } catch (error) {
          if (this.life.signal.aborted) return;
          if (!mainAdded && !attemptedWrite) {
            this.restorePurchaseControls();
            return;
          }
          this.phase = 'uncertain';
          this.errorBox.textContent = this.dataset.addonError;
          this.errorBox.hidden = false;
          this.dialog.querySelector('[data-review]').hidden = false;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.dialog.querySelector('[data-review]').focus();
        }
      }

      dismiss() {
        if (this.phase !== 'offering') return;
        this.dialog.close();
        document.documentElement.style.overflow = this.oldOverflow;
        this.phase = 'idle';
        if (this.trigger?.isConnected) this.trigger.focus();
      }

      disconnectedCallback() {
        this.life?.abort();
        this.observer?.disconnect();
        if (this.dialog?.open) document.documentElement.style.overflow = this.oldOverflow;
        this.dialog?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-navigation')) {
    customElements.define(
      'featured-collection-navigation',
      class extends HTMLElement {
        connectedCallback() {
          this.scheduleUpdate = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.updateVisibility();
            });
          };

          this.desktopMedia = window.matchMedia('(min-width: 1024px)');
          this.activateNavigation = () => {
            if (!this.desktopMedia.matches) {
              this.visibilityObserver?.disconnect();
              this.disconnectSlider();
              this.setAttribute('data-overflow', 'false');
              return;
            }
            if (this.slider) return;
            const section = this.closest('.shopify-section') || this.parentElement;
            if ('IntersectionObserver' in window) {
              this.visibilityObserver?.disconnect();
              this.visibilityObserver = new IntersectionObserver((entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                this.visibilityObserver.disconnect();
                this.connectSlider();
              }, { rootMargin: '400px 0px' });
              this.visibilityObserver.observe(section);
            } else {
              this.frame = requestAnimationFrame(() => this.connectSlider());
            }
          };
          this.desktopMedia.addEventListener('change', this.activateNavigation);
          this.activateNavigation();
        }

        connectSlider() {
          if (!this.isConnected || !this.desktopMedia.matches || this.slider) return;

          this.slider = document.getElementById(this.dataset.sliderId);
          if (!this.slider) return;

          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.observeSizes();

          this.mutationObserver = new MutationObserver(() => {
            this.observeSizes();
            this.scheduleUpdate();
          });

          this.mutationObserver.observe(this.slider, {
            childList: true,
            subtree: true
          });

          this.slider.addEventListener('scroll', this.scheduleUpdate, {
            passive: true
          });

          window.addEventListener('resize', this.scheduleUpdate, {
            passive: true
          });

          this.updateVisibility();
        }

        observeSizes() {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.slider);

          this.slider
            .querySelectorAll('.card-grid, .card-grid > *')
            .forEach((element) => {
              this.resizeObserver.observe(element);
            });
        }

        updateVisibility() {
          if (!this.slider || !this.isConnected) return;

          const isDesktop = window.matchMedia(
            '(min-width: 1024px)'
          ).matches;

          const maxScroll =
            this.slider.scrollWidth - this.slider.clientWidth;

          const hasOverflow =
            this.slider.clientWidth > 0 && maxScroll > 1;

          this.setAttribute(
            'data-overflow',
            String(isDesktop && hasOverflow)
          );

          // Restore buttons if the theme previously hid them when
          // all products fitted, then update the disabled edge states.
          if (isDesktop && hasOverflow) {
            const previous = this.querySelector(
              '[is="previous-button"]'
            );

            const next = this.querySelector(
              '[is="next-button"]'
            );

            const position = Math.abs(this.slider.scrollLeft);

            if (previous) {
              previous.hidden = false;
              previous.disabled = position <= 1;
            }

            if (next) {
              next.hidden = false;
              next.disabled = position >= maxScroll - 1;
            }
          }
        }

        disconnectSlider() {
          cancelAnimationFrame(this.frame);
          this.resizeObserver?.disconnect();
          this.mutationObserver?.disconnect();

          this.slider?.removeEventListener(
            'scroll',
            this.scheduleUpdate
          );

          window.removeEventListener(
            'resize',
            this.scheduleUpdate
          );
          this.slider = null;
        }

        disconnectedCallback() {
          this.visibilityObserver?.disconnect();
          this.desktopMedia?.removeEventListener('change', this.activateNavigation);
          this.disconnectSlider();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expandable-rich-text')) {
    customElements.define('expandable-rich-text', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const viewport = this.querySelector('.expandable-text__viewport');
        const full = this.querySelector('.expandable-text__full');
        const preview = this.querySelector('.expandable-text__preview');
        const button = this.querySelector('.expandable-text__button');
        if (!viewport || !full || !preview || !button) return;
        this.initialized = true;

        const copy = full.cloneNode(true);
        copy.querySelectorAll('br').forEach(element => element.replaceWith(' '));
        copy.querySelectorAll('p, li, div, h1, h2, h3, h4, h5, h6').forEach(element => element.append(' '));
        const text = copy.textContent.replace(/\s+/g, ' ').trim();
        const characters = Array.from(text);
        const configuredLimit = Number(this.dataset.characterLimit);
        const characterLimit = Number.isFinite(configuredLimit) && configuredLimit >= 1
          ? Math.floor(configuredLimit)
          : 200;
        if (characters.length <= characterLimit) return;

        const paragraph = document.createElement('p');
        paragraph.textContent = characters.slice(0, characterLimit).join('').trimEnd() + '…';
        preview.append(paragraph);
        full.hidden = true;
        preview.hidden = false;
        button.hidden = false;

        const viewMoreLabel = button.textContent.trim();
        const viewLessLabel = this.dataset.viewLess;
        let expanded = false;
        let animation;

        button.addEventListener('click', () => {
          const startHeight = viewport.getBoundingClientRect().height;
          if (animation) animation.cancel();
          viewport.style.overflow = '';

          expanded = !expanded;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? viewLessLabel : viewMoreLabel;
          preview.hidden = expanded;
          full.hidden = !expanded;

          const endHeight = viewport.getBoundingClientRect().height;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && viewport.animate) {
            viewport.style.overflow = 'hidden';
            animation = viewport.animate(
              [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
              { duration: 400, easing: 'ease-in-out' }
            );
            const currentAnimation = animation;
            const cleanup = () => {
              if (animation !== currentAnimation) return;
              viewport.style.overflow = '';
              animation = null;
            };
            currentAnimation.addEventListener('finish', cleanup, { once: true });
            currentAnimation.addEventListener('cancel', cleanup, { once: true });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
